import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import YouMayAlsoLikeOffersCarousel from 'components/Recommendations/YouMayAlsoLike/Shared/YouMayAlsoLikeOffersCarousel'
import useOffers from 'hooks/Offers/useOffers'
import { take } from 'lib/array/arrayUtils'
import { isBedbankOffer, isLEOffer } from 'lib/offer/offerTypes'
import React from 'react'
import { connect } from 'react-redux'
import { getOfferBasedLereState } from 'selectors/recommendations'

interface OwnProps {
  seedOffer: App.AnyOffer
  isWithPromo: boolean
}

interface Props extends OwnProps {
  offerIds: Array<string>;
}

function SecondChanceModalOfferCarousel({ offerIds, isWithPromo }:Props) {
  const [offers] = useOffers<App.Offer | App.BedbankOffer>(take(offerIds, 3))

  return (
    <>
      {isWithPromo &&
        <HeadingTextBlock variant="heading6">
          Top-rated escapes our customers love. Don’t miss these deals!
        </HeadingTextBlock>}
      <YouMayAlsoLikeOffersCarousel
        offers={offers}
        arrowsOnlyOnHover
      />
    </>
  )
}

function isLEOfferOrBedbankOffer(offer: App.AnyOffer) {
  return isLEOffer(offer) || isBedbankOffer(offer)
}

function mapState(state: App.State, ownProps: OwnProps) {
  const { seedOffer } = ownProps

  if (isLEOfferOrBedbankOffer(seedOffer)) {
    const { offerIds } = getOfferBasedLereState(state, seedOffer)
    return {
      offerIds,
    }
  }

  return {
    offerIds: [],
  }
}

export default connect(mapState)(SecondChanceModalOfferCarousel)
